import { render, staticRenderFns } from "./FetchSources.vue?vue&type=template&id=2229884e&"
import script from "./FetchSources.vue?vue&type=script&lang=js&"
export * from "./FetchSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports